import React, { useContext, useState } from 'react';
import { toast } from 'sonner';
import { ShieldCheck, UserCog } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AuthContext from '@/contexts/AuthContext';
import { assistApi, BRANDS, OVERALL } from './assistApi';
import { ApproveNowDialog } from './ApproveNowDialog';

/** Per-brand Ox Approved chips, one-tap "Approve" and "Complete for them" on the Manage Installers card. */
export function OxApprovedStrip({ installer, summary = {}, onAssist, onApproved }) {
  const { user } = useContext(AuthContext);
  const canApprove = ['admin', 'manager'].includes(user?.role);
  const [quick, setQuick] = useState(null);
  const brands = BRANDS.filter((b) => installer.access?.[b.id]);
  if (!brands.length) return null;

  const openQuick = async (e, b) => {
    e.stopPropagation();
    try { setQuick({ brand: b, record: await assistApi.get(installer.user_id, b.id) }); } catch (err) { toast.error(err.message); }
  };

  return (
    <div className="mb-3 border-t border-gray-100 pt-2" data-testid={`ox-strip-${installer.user_id}`}>
      <div className="flex items-center justify-between mb-1">
        <div className="text-[10px] uppercase tracking-wider text-gray-400 font-bold flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> Ox Approved</div>
        <Button variant="ghost" size="sm" className="h-6 px-2 text-[11px] text-[#7A0B7A] hover:bg-purple-50" onClick={(e) => { e.stopPropagation(); onAssist(brands[0].id); }} data-testid={`ox-assist-${installer.user_id}`}>
          <UserCog className="w-3.5 h-3.5 mr-1" /> Complete for them
        </Button>
      </div>
      <div className="space-y-1">
        {brands.map((b) => {
          const status = installer.ox_approved?.[b.id] ? 'approved' : summary[b.id] || 'not_started';
          const meta = OVERALL[status] || OVERALL.not_started;
          return (
            <div key={b.id} className="flex items-center gap-1.5">
              <button type="button" onClick={(e) => { e.stopPropagation(); onAssist(b.id); }} data-testid={`ox-chip-${b.id}-${installer.user_id}`}
                className={`px-2 py-0.5 rounded-full text-[11px] font-semibold border hover:ring-2 hover:ring-offset-1 hover:ring-gray-200 ${meta.cls}`}>
                {b.label}: {meta.label}
              </button>
              {canApprove && status !== 'approved' && (
                <button type="button" onClick={(e) => openQuick(e, b)} data-testid={`ox-quick-approve-${b.id}-${installer.user_id}`}
                  className="ml-auto inline-flex items-center gap-1 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-[11px] font-semibold px-2 py-0.5 active:scale-95 transition-transform">
                  <ShieldCheck className="w-3 h-3" /> Approve
                </button>
              )}
            </div>
          );
        })}
      </div>
      {quick && (
        <ApproveNowDialog open onClose={() => setQuick(null)} record={quick.record} brandLabel={quick.brand.label} notify
          onApproved={(d) => { onApproved?.(d); setQuick(null); }} />
      )}
    </div>
  );
}
